


const services = [
  {
    title: 'Expedited Shipping',
    description:
      'When time is critical, our expedited freight solutions ensure your load arrives fast — no compromises, no delays.',
    image: '/image4.png',
  },
  {
    title: '24/7 Dispatch',
    description:
      'Our dispatch team is available around the clock, keeping your shipments moving and your business running smoothly.',
    image: '/img_1922.jpg',
  },
  {
    title: 'Dedicated Services',
    description:
      'Tailored transportation solutions built around your business — dedicated lanes, consistent drivers, and full flexibility.',
    image: '/img_3074.jpg',
  },
];

const regions = [
  'Northeast', 'Southeast', 'Midwest', 'Southwest', 'Mountain West', 'Pacific Coast',
];

const Services = () => {
  return (
    <section id="services" className="services">
      <div className="container">
        {/* Section Header */}
        <div className="section-header" data-aos="fade-up">
          <span className="section-label">What We Do</span>
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            End-to-end freight solutions designed to keep your supply chain moving efficiently.
          </p>
        </div>

        {/* Service Cards */}
        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-md-6 col-lg-4" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="service-card">
                <div className="service-card__img-wrap">
                  <img
                    src={service.image}
                    className="service-card__img"
                    alt={service.title}
                  />
                </div>
                <div className="service-card__body">
                  <h5 className="service-card__title">{service.title}</h5>
                  <p className="service-card__desc">{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Coverage Section — replaces the low-quality map */}
        <div className="coverage" data-aos="fade-up">
          <p className="coverage__eyebrow">Nationwide Coverage</p>
          <h2 className="coverage__title">All 48 Contiguous States</h2>
          <p className="coverage__sub">
            C.H.I. Logistics operates across the entire continental United States,
            providing reliable freight services from coast to coast.
          </p>
          <div className="coverage__regions">
            {regions.map((region) => (
              <span key={region} className="coverage__region">{region}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
